import { COLUMN_DATA_TYPE_NAMES, COLUMN_DATA_TYPES } from "../types/constants";
import ClearableSearchField from "./ClearableSearchField";
import DataTypeIcon from "./DataTypeIcon";
import { AllInclusive as AnyIcon } from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";

export const TYPE_COLORS = {
  text: { bg: "#fcebf1", border: "#f8bbd0", text: "#8e2453" },
  option: { bg: "#fce4ec", border: "#f48fb1", text: "#c2185b" },
  date: { bg: "#e3f2fd", border: "#90caf9", text: "#1565c0" },
  binary: { bg: "#fff3e0", border: "#ffb74d", text: "#e65100" },
  unit: { bg: "#e8f5e9", border: "#81c784", text: "#2e7d32" },
  currency: { bg: "#dcedc8", border: "#7cb342", text: "#33691e" },
  percentage: { bg: "#f1f8e9", border: "#c5e1a5", text: "#558b2f" },
  aggregate: { bg: "#ede7f6", border: "#b39ddb", text: "#4527a0" },
  groupAggregate: { bg: "#ffebee", border: "#ef9a9a", text: "#b71c1c" },
};

export const ANY_TYPE_COLORS = {
  bg: "transparent",
  border: "#c4c4c4",
  text: "#757575",
};

const SX_FILTER_ROW = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
};

export const CircleFilterButton = ({
  title,
  isActive,
  colors,
  onClick,
  children,
}) => (
  <Box
    component={"button"}
    type={"button"}
    onClick={onClick}
    aria-pressed={isActive}
    title={title}
    sx={{
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: `1px solid ${colors.border}`,
      backgroundColor: isActive ? colors.border : colors.bg,
      color: colors.text,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.15s ease",
      flexShrink: 0,
      boxShadow: isActive
        ? "inset 0 2px 4px rgba(0,0,0,0.2)"
        : "0 1px 2px rgba(0,0,0,0.1)",
      "&:hover": {
        backgroundColor: colors.border,
        transform: "translateY(-1px)",
      },
      "&:active": { transform: "translateY(0)" },
    }}
  >
    {children}
  </Box>
);

const ColumnFilterBar = ({
  filterText,
  onFilterTextChange,
  selectedDisplayTypes,
  onToggleType,
  onSelectAnyMode,
  isAnyTypeMode,
  typeCounts,
  totalCount,
  filteredCount,
  placeholder = "columns",
}) => (
  <>
    <ClearableSearchField
      value={filterText}
      onChange={onFilterTextChange}
      placeholder={placeholder}
      countDisplay={{ filtered: filteredCount, total: totalCount }}
    />
    <Box sx={SX_FILTER_ROW}>
      <CircleFilterButton
        title={`any (${totalCount})`}
        isActive={isAnyTypeMode}
        colors={ANY_TYPE_COLORS}
        onClick={onSelectAnyMode}
      >
        <AnyIcon sx={{ fontSize: 16 }} />
      </CircleFilterButton>
      {COLUMN_DATA_TYPES.filter((type) => (typeCounts[type] ?? 0) > 0).map(
        (type) => {
          const colors = TYPE_COLORS[type];
          if (!colors) return null;
          return (
            <CircleFilterButton
              key={type}
              title={`${COLUMN_DATA_TYPE_NAMES[type] ?? type} (${
                typeCounts[type]
              })`}
              isActive={selectedDisplayTypes.has(type)}
              colors={colors}
              onClick={() => onToggleType(type)}
            >
              <DataTypeIcon type={type} />
            </CircleFilterButton>
          );
        }
      )}
    </Box>
  </>
);

export default ColumnFilterBar;
